import Commons from '../../../Services/Common/Common';

/**
 * 작업중지 작성 (M_WOS_BASIC_01) 요청 파라미터 매핑
 * 사용처: M_WOS_BASIC_01_Query.js (useSearch1~3, useSave1, useSave2)
 */
export const WOS_BASIC_01_Schema = {
  /** 화면 폼 필드 정의 (initial, label, required, placeholder, maxLength) - createInitial / InputText schema 참조 */
  fields: {
    stopComment: {
      initial: '',
      label: '내용',
      required: 'Y',
      placeholder: '내용을 입력하세요.',
      maxLength: 1000,
    },
  },

  mapper: {
    /** useSearch3 → GetWosBasic01R3 (부서 인원 + EMT 조회) */
    search3: {
      UserId: (context) =>
        Commons.EncryptAES(context.userInfo?.decUserId ?? '') || '',
      StopAuth: (context) =>
        Commons.EncryptAES(context.stopAuth ?? '') || '',
      DepCd: (context) => {
        const dep =
          context.depCd ??
          (Array.isArray(context.depCdList)
            ? context.depCdList.join(',')
            : '');
        return Commons.EncryptAES(dep) || '';
      },
      CustCd: (context) =>
        Commons.EncryptAES(context.userInfo?.custCd ?? '') || '',
    },
    /** useSearch4 → GetWosBasic01R4 (동일부서 결재권자 + 동일사업장 안전관리자) SaveLogic3용 */
    search4: {
      UserId: (context) => context.userInfo?.userid ?? '',
    },
    search5: {
      AuthCd: (context) =>
        Commons.EncryptAES(context.userInfo?.authCd || '') || '',
      CoCd: (context) =>
        Commons.EncryptAES(
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.coCd
            : context.userInfo?.coCd || ''
        ) || '',
      CustCd: (context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      SearchText: (context) =>
        Commons.EncryptAES(context.search?.searchText || '') || '',
    },
    /** useSearch6 → GetEmTelR1 (비상연락망 조회) */
    search6: {
      DepCd: (context) => Commons.EncryptAES(context.userInfo?.depCd),
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd),
      UserId: (context) => context.userInfo?.userid,
    },
    /** useSave1 → SaveWosBasic01U1 (작업중지 등록) */
    save1: {
      WorkStopCd: (ctx) => Commons.EncryptAES(ctx?.workStopCd ?? '') || '',
      DepCd: (ctx) => Commons.EncryptAES(ctx?.depCd ?? '') || '',
      TargetDepCd: (ctx) =>
        Commons.EncryptAES(ctx?.targetDepCd ?? '') || '',
      EmtYn: (ctx) => Commons.EncryptAES(ctx?.emtYn ?? 'N') || '',
      StopAuth: (ctx) => Commons.EncryptAES(ctx?.stopAuth ?? '') || '',
      StopComment: (ctx) => Commons.EncryptAES(ctx?.stopComment ?? '') || '',
      StopImagePath: (ctx) =>
        Commons.EncryptAES(ctx?.stopImagePath ?? '') || '',
      UserId: (ctx) => ctx.userInfo?.userid ?? '',
    },
    /** useSave2 → SaveWosBasic01U2 (작업중지 멤버 저장) body item */
    save2Item: {
      WorkStopCd: (ctx) => Commons.EncryptAES(ctx?.workStopCd ?? '') || '',
      StopId: (ctx) => Commons.EncryptAES(ctx?.stopId ?? '') || '',
      UserId: (ctx) => ctx.userInfo?.userid ?? '',
    },
  },
};
